module.exports = __webpack_public_path__ + "static/media/AddDelegateRepeater.3a82d6ae.svg";